
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const debounce = function (fn, delay) {
    var timeoutID = null
    return function () {
      clearTimeout(timeoutID)
      var args = arguments
      var that = this
      timeoutID = setTimeout(function () {
        fn.apply(that, args)
      }, delay)
    }
  }

const formatDate = function(day, format, toUpperCase){
    dayjs.extend(utc);
    const formatted = dayjs.utc(day).format(format);
    return toUpperCase ? formatted.toUpperCase() : formatted;
  }
const formatTime = function(timeStr) {
  const timeStrSplit = timeStr.split(":");
  let ap = "AM";
  let hour = Number(timeStrSplit[0]);
  if (hour >= 12) {
    hour = hour > 12 ? hour - 12 : hour;
    ap = "PM";
  }
  if (hour === 0) {
    hour = 12;
  }
  return hour + ":" + timeStrSplit[1] + ` ${ap}`;
}
export {
  formatDate,
  debounce,
  formatTime
}
